// src/components/Icon.jsx
import React from 'react';

// Import all your PNG icons
import AccessControlIcon from '../../images/AccessControl.png';
import AnalyticsIcon from '../../images/Analytics.png';
import InfringementIcon from '../../images/Infringement.png';
import LPRIcon from '../../images/LPR.png';
import ReportingIcon from '../../images/Reporting.png';
import Capa_2 from '../../images/Capa_2.png';
import SamuraiAnalyticsIcon from '../../images/samurai-analytics.png';
import JourneyLPRIcon from '../../images/JourneyLPR.png';

// Icon mapping object
const iconMap = {
  'access-control': AccessControlIcon,
  
  'analytics': AnalyticsIcon,

  'reporting': ReportingIcon,

  'samurai-1': Capa_2,

  'infringement': InfringementIcon,

  'samurai-analytics': SamuraiAnalyticsIcon,
  
  'lpr': LPRIcon,

  'lpr-journey': JourneyLPRIcon,

};

// Get all available icon names for easy reference
export const availableIcons = Object.keys(iconMap);

const Icon = ({
  name,
  size = '24px',
  width,
  height,
  alt,
  className = '',
  style = {},
  onClick,
  ...props
}) => {
  // Get the icon source
  const iconSrc = iconMap[name];
  
  // If icon doesn't exist, return a placeholder or null
  if (!iconSrc) {
    console.warn(`Icon "${name}" not found. Available icons:`, availableIcons);
    return (
      <div 
        className={`icon-placeholder ${className}`}
        style={{
          width: width || size,
          height: height || size,
          backgroundColor: '#ccc',
          border: '1px dashed #999',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '10px',
          color: '#666',
          ...style
        }}
        {...props}
      >
        ?
      </div>
    );
  }

  return (
    <img
      src={iconSrc}
      alt={alt || `${name} icon`}
      className={`ui-icon ${className}`}
      style={{
        width: width || size,
        height: height || size,
        display: 'inline-block',
        verticalAlign: 'middle',
        ...style
      }}
      onClick={onClick}
      {...props}
    />
  );
};

export default Icon;